<div data-cy="preview-geo-json-modal__page" mat-dialog-title>
    <span data-cy="preview-geo-json-modal__open-geo-json-select-modal-2" class="generic-color d-cursor-hand" (click)="openGeoJsonSelectModal()">
        <i class="uil uil-angle-left-b"></i>
        <h4 class="ml-10 mb-10 inline-block ts-20">{{ 'imports.file_control' | transloco }}</h4>
    </span>
    <button data-cy="preview-geo-json-modal__close-btn" type="button" class="close modal-close-button" (click)="close()" ><span aria-hidden="true">
    <i class="d-text-middle uil uil-multiply unicon-icon"></i>
    </span><span class="sr-only">{{ 'reusable.close' | transloco }}</span></button>
</div>

<mat-dialog-content data-cy="preview-geo-json-modal__dialog-content">
    <mat-tab-group class="tabs-group" [selectedIndex]="selectedTabIndex">
        <mat-tab [label]="( 'imports.errors' | transloco ) + ' (' + (errorsData?.length || 0) + ')'" [disabled]="isFileValid !== false">
            <mat-progress-bar mode="indeterminate" *ngIf="isValidating"></mat-progress-bar>
            <!-- CASE 1: If file is JSON/GEOJSON and has error -->
            <ng-container *ngIf="!isFileValid && !isValidating">
                <p class="table-txt mt-20">
                    {{ 'imports.adjust_values_message' | transloco }}
                </p>
                <table data-cy="preview-geo-json-modal__table" mat-table [dataSource]="errorsData" class="error-table mt-30" *ngIf="data.fileType === 'xlsx' || data.fileType === 'xls'">
                    <!-- Rij nummer Column -->
                    <ng-container matColumnDef="rijNummer">
                        <th mat-header-cell *matHeaderCellDef>
                        <span class="font-normal">{{ 'imports.row_number' | transloco }}</span>
                        <i class="uil uil-arrow-down ml-6"></i>
                        </th>
                        <td mat-cell *matCellDef="let element">{{ element.row }}</td>
                    </ng-container>
                    
                    <!-- Rij nummer Column -->
                    <ng-container matColumnDef="sheet">
                        <th mat-header-cell *matHeaderCellDef>
                        <span class="font-normal">Sheet</span>
                        <i class="uil uil-arrow-down ml-6"></i>
                        </th>
                        <td mat-cell *matCellDef="let element">{{ element.sheet | capitaliz }}</td>
                    </ng-container>

                    <!-- Heading Column -->
                    <ng-container matColumnDef="heading">
                        <th mat-header-cell *matHeaderCellDef>
                        <span class="font-normal">{{ 'imports.heading' | transloco }}</span>
                        <i class="uil uil-arrow-down ml-6"></i>
                        </th>
                        <td mat-cell *matCellDef="let element">{{ element.column }}</td>
                    </ng-container>

                    <!-- Waarde Column -->
                    <ng-container matColumnDef="waarde">
                        <th mat-header-cell *matHeaderCellDef>
                        <span class="font-normal">{{ 'imports.value' | transloco }}</span>
                        <i class="uil uil-arrow-down ml-6"></i>
                        </th>
                        <td mat-cell *matCellDef="let element">{{ element.value }}</td>
                    </ng-container>

                    <!-- Error Column -->
                    <ng-container matColumnDef="error">
                        <th mat-header-cell *matHeaderCellDef>
                        <span class="font-normal">{{ 'imports.error' | transloco }}</span>
                        <i class="uil uil-arrow-down ml-6"></i>
                        </th>
                        <td mat-cell *matCellDef="let element">{{ element.message }}</td>
                    </ng-container>

                    <!-- Table Header & Rows -->
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                </table>

                <table data-cy="preview-geo-json-modal__table-2" mat-table [dataSource]="errorsData" class="error-table mt-30" *ngIf="data.fileType === 'json' || data.fileType === 'geojson'">
                    <!-- Rij nummer Column -->
                    <ng-container matColumnDef="item_layer">
                        <th mat-header-cell *matHeaderCellDef>
                        <span class="font-normal">{{ 'imports.item_layer' | transloco }}</span>
                        <i class="uil uil-arrow-down ml-6"></i>
                        </th>
                        <td mat-cell *matCellDef="let element">{{ element.item_name }}</td>
                    </ng-container>

                    <!-- Heading Column -->
                    <ng-container matColumnDef="item_name">
                        <th mat-header-cell *matHeaderCellDef>
                        <span class="font-normal">{{ 'imports.item' | transloco }}</span>
                        <i class="uil uil-arrow-down ml-6"></i>
                        </th>
                        <td mat-cell *matCellDef="let element">{{ element.item_name }}</td>
                    </ng-container>

                    <!-- Error Column -->
                    <ng-container matColumnDef="errors">
                        <th mat-header-cell *matHeaderCellDef>
                        <span class="font-normal">{{ 'imports.error' | transloco }}</span>
                        <i class="uil uil-arrow-down ml-6"></i>
                        </th>
                        <td mat-cell *matCellDef="let element">{{ element.errors }}</td>
                    </ng-container>

                    <!-- Table Header & Rows -->
                    <tr mat-header-row *matHeaderRowDef="displayedErrorsColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedErrorsColumns"></tr>
                </table>
            </ng-container>

            <!-- CASE 2: If file is Excel and has error -->
            <ng-container *ngIf="data?.error">
                <div class="notification-bar mt-10">
                <span class="warn-msg">
                    <i class="uil uil-exclamation-triangle"></i>
                    <p>{{ 'imports.file_type_not_supported' | transloco }}</p>
                </span>
                <span data-cy="preview-geo-json-modal__open-geo-json-select-modal-3" class="detail-grp d-cursor-hand" (click)="openGeoJsonSelectModal()">
                    <span class="details-link fs-8">{{ 'imports.select_new_file' | transloco }}</span>
                    <i class="uil uil-angle-right-b fs-25"></i>
                </span>
                </div>

                <p class="mt-20 msg">
                    {{ 'imports.file_type_not_supported_description' | transloco }}
                </p>

                <div class="col-xs-12">
                <div class="import-template">
                    <i class="uil uil-table"></i>
                    <span>{{ 'imports.import_templates' | transloco }}</span>
                </div>
                <mat-divider></mat-divider>
                </div>

                <div class="col-xs-12">
                <div class="template-wrapper">
                    <div class="template-description">
                    <div class="template-title">
                        <i class="uil uil-file"></i>
                        <h3>{{ 'imports.template_title' | transloco }}</h3>
                        <span>{{ 'imports.excel_file' | transloco }}</span>
                    </div>
                    <span class="descr">
                        {{ 'imports.template_description' | transloco }}
                    </span>
                    </div>
                    <button data-cy="preview-geo-json-modal__btn" mat-stroked-button>{{ 'imports.download' | transloco }}</button>
                </div>
                <mat-divider></mat-divider>
                </div>
            </ng-container>
        </mat-tab>

        <!-- GeoJson File Preview -->
        <mat-tab [label]="'imports.preview' | transloco" [disabled]="isFileValid === false && (data.fileType === 'json' || data.fileType === 'geojson')"> 
            <mat-progress-bar mode="indeterminate" *ngIf="isValidating || (isExcelFile() && isExcelPreviewLoading())"></mat-progress-bar>
            <ng-container *ngIf="isExcelFile() && !isValidating">
                <ng-container *ngIf="!isExcelPreviewLoading()">
                    <div class="notification-bar bg-rm mt-10 mb-30">
                        <span class="warn-msg" *ngIf="!isFileValid && errorsData.length">
                            <i class="uil uil-exclamation-triangle"></i>
                            <p>{{ 'imports.preview_message' | transloco }}</p>
                        </span>
                        <!-- <div class="pull-right expand-inst pr-6 d-cursor-hand mblk-0">
                            <span class="mr-6">{{ 'imports.enlarge' | transloco }}</span>
                            <i class="uil uil-expand-arrows-alt"></i>
                        </div> -->
                    </div>
                    
                    <div class="flex align-center justify-btw">
                        <span class="ml-8 blk-clr">
                            <img [style.width.px]="22" [style.height.px]="22" src="assets/icons/excel_icon.svg" alt="excel">
                            {{data.file.name}}
                        </span>
                        <div class="required-fields-legend">
                            <strong style="color: red; font-weight: bold;">* </strong><strong>{{"imports.required_fields" | transloco}}</strong>
                        </div>
                    </div>
                    <div class="spreadsheet-wrapper mt-10">
                        <div class="spreadsheet-container">
                            <hot-table
                            [hotId]="'excelTable'"
                            [settings]="settings"
                            [data]="currentSheetData"
                            [columns]="buildColumnsConfig()"
                            [rowHeaders]="true"
                            [filters]="true"
                            [dropdownMenu]="true"
                            [contextMenu]="true"
                            [width]="'100%'"
                            [height]="270"
                            [licenseKey]="'non-commercial-and-evaluation'"
                            ></hot-table>
                        </div>
                        
                        <!-- Sheet Tabs at Bottom (Excel-like) -->
                        <div class="sheet-tabs-container" *ngIf="sheetNames.length > 0">
                            <button data-cy="preview-geo-json-modal__sheet-nav-btn" class="sheet-nav-btn">
                                <i class="uil uil-bars"></i>
                            </button>
                            <!-- [class.active]="errorsData.length" -->
                            <div class="sheet-tabs">
                                <button data-cy="preview-geo-json-modal__sheet-tab-btn" 
                                    *ngFor="let name of sheetNames" 
                                    class="sheet-tab" 
                                    [ngClass]="{
                                        active: selectedSheet === name && !hasSheetErrors(name),
                                        error: hasSheetErrors(name),
                                        'active-with-error': hasSheetErrors(name) && selectedSheet === name
                                    }"
                                    (click)="loadSheet(name)">
                                    {{ getSheetTranslationKey(name) | transloco | capitaliz }}
                                </button>
                            </div>
                        </div>
                    </div>
                    
                    <div class="empty-state" *ngIf="currentSheetData.length === 0">
                        <i class="uil uil-file-upload"></i>
                        <p>{{ 'imports.upload_excel_preview' | transloco }}</p>
                    </div>
                </ng-container>
            </ng-container>

            <ng-container *ngIf="(data?.fileType === 'geojson' || data?.fileType === 'json') && !isValidating">
                <p class="table-txt mt-10 mb-10" *ngIf="previewCapped && previewTotalFeatures != null">
                  {{ 'imports.partial_preview' | transloco:{ shown: previewShownFeatures, total: previewTotalFeatures } }}
                </p>
                <p class="table-txt mt-10 mb-10" *ngIf="previewSkippedUnsupported > 0">
                  {{ 'imports.skipped_unsupported' | transloco:{ count: previewSkippedUnsupported } }}
                </p>
                <div class="pull-right expand-inst pr-6 d-cursor-hand" (click)="goFullscreen()">
                    <span class="mr-6">Vergroten</span>
                    <i class="uil uil-expand-arrows-alt"></i>
                </div>

                <!-- Map Section -->
                <div class="col-xs-12" >
                    <div class="col-xs-4 expansion-panels-wrapper">
                        <mat-accordion class="items-accordion">
                            <mat-expansion-panel #itemsPanel>
                                <mat-expansion-panel-header [class.border-b]="!itemsPanel.expanded">
                                <mat-panel-title>
                                    <strong>{{ 'imports.items' | transloco }} {{ previewStakeholderTotal }}</strong>
                                </mat-panel-title>
                                </mat-expansion-panel-header>

                                <div class="item-row" *ngFor="let item of items">
                                    <div class="item-info">
                                        <i class="uil uil-map-marker" [ngStyle]="{ color: item.color }"></i>
                                        <span class="item-label">{{ item.name }}</span>
                                    </div>
                                    <mat-slide-toggle data-cy="preview-geo-json-modal__enabled-toggle"
                                        color="primary"
                                        [(ngModel)]="item.enabled"
                                        (change)="onToggle(item)"
                                    ></mat-slide-toggle>
                                </div>
                            </mat-expansion-panel>
                            <mat-expansion-panel #customDataPanel>
                                <mat-expansion-panel-header [class.border-b]="!customDataPanel.expanded">
                                    <mat-panel-title>
                                        <strong>{{ 'imports.custom_data' | transloco }} ({{ customData.length }})</strong>
                                    </mat-panel-title>
                                </mat-expansion-panel-header>

                                <div class="item-row" *ngFor="let item of customData">
                                    <div class="item-info">
                                        <i class="uil uil-map-marker" [ngStyle]="{ color: item.color }"></i>
                                        <span class="item-label">{{ item.name | trunc:10}}</span>
                                    </div>
                                    <mat-slide-toggle data-cy="preview-geo-json-modal__enabled-toggle-2"
                                        color="primary"
                                        [(ngModel)]="item.enabled"
                                        (change)="onToggle(item)"
                                    ></mat-slide-toggle>
                                </div>
                            </mat-expansion-panel>
                        </mat-accordion>
                    </div>

                    <div class="col-xs-8" *ngIf="showMap">
                        <app-openlayers-map data-cy="preview-geo-json-modal__openlayers-map" [(ngModel)]="geojsonData" name="" [includeSidebar]="false" [defaultCoordinate]="globals.nederlandMap" [integrationTabMap]='false' [showMapReset]="false"
                            [showPinTooltip]="false" [singleEntityType]="false" locatableType="" defaultDrawTool="" [clickStartDrawingMsg]="'projects.Teken subprojectgebied' | transloco" required>
                        </app-openlayers-map>
                    </div>
                </div>
            </ng-container>
            
        </mat-tab>
    </mat-tab-group>
</mat-dialog-content>

<mat-dialog-actions data-cy="preview-geo-json-modal__dialog-actions" align="end" class="mt-35 pb-35">
    <a data-cy="preview-geo-json-modal__open-geo-json-select-modal" (click)="openGeoJsonSelectModal()">{{ 'imports.previous_step' | transloco }}</a>
    <button data-cy="preview-geo-json-modal__save-geo-json-file-btn" mat-flat-button class="ml-15" 
        (click)="saveGeoJsonFile()" 
        [disabled]="isValidating || !data?.file || !isFileValid || isImporting || (isExcelFile() && !isExcelContentValid) || (!isExcelFile() && !isGeoJsonStreamComplete)">
        {{ 'imports.import' | transloco }}
    </button>
</mat-dialog-actions>